import React from 'react';
import { PollContent as DefaultPollContent } from './PollContent';
import { QuotedPoll as DefaultQuotedPoll } from './QuotedPoll';
import { PollProvider, useComponentContext } from '../../context';
export const Poll = ({ isQuoted, poll }) => {
    const { PollContent = DefaultPollContent, QuotedPoll = DefaultQuotedPoll } = useComponentContext();
    return poll ? (React.createElement(PollProvider, { poll: poll }, isQuoted ? React.createElement(QuotedPoll, null) : React.createElement(PollContent, null))) : null;
};
